import React from 'react';
import { Button } from 'js/components/main/LeaderboardButton/Button';
import style from './index.scss';

export default ({ className = '', onClick = () => { }, disabled = false, character = '', importedStyle = style }) => {
    let classes = [importedStyle.button, importedStyle.circular];
    classes = classes.join(' ');
    classes += ` ${className}`;
    return (
        <Button
            view='primary'
            variant='rounded'
            size='large'
            color='generic'
            onClick={onClick}
            disabled={disabled}
            className={classes}>
            <span>{character}</span>
        </Button>
    );
};
